<cm-overlay
  [header]="header"
  [width]="800"
  [height]="600"
  >
  @if (lock) {
    <div>
      <mat-progress-spinner></mat-progress-spinner>
    </div>
  }
  @if (!lock) {
    <div>
      <h1 class="confirmation">{{ noSupportersMessage }}</h1>
      @if (choices) {
        <cm-choice-selector
          [choices]="choices"
          (choiceSelected)="sendCallRequest($event)"
          [choiceWidth]="600"
          [choiceHeight]="110"
          showAvatar="true"
        ></cm-choice-selector>
      }
    </div>
  }
</cm-overlay>
